module.exports = __webpack_public_path__ + "static/img/2s-info-b5.ef567c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/2s-info-b5.jpg
// module id = i+C4
// module chunks = 0